<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
        
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Sign in </small>
                            </div>
                            <form role="form">
                                <base-input alternative
                                            class="mb-3"
                                            v-model = "form.uid"
                                            placeholder="Username"
                                            addon-left-icon="ni ni-single-02">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            v-model = "form.password"
                                            placeholder="Password"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <small class="text-light">{{indicator}}</small>
                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click="loginProcess">Login</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <!--div class="row mt-3">
                        <div class="col-6">
                            <a href="#" class="text-light">
                                <small>Forgot password?</small>
                            </a>
                        </div>
                        <div class="col-6 text-right">
                            <a href="/register" class="text-light">
                                <small>Create new account</small>
                            </a>
                        </div>
                    </div-->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
export default {
    name: 'login-page',
    bodyClass: 'login-page',
    data(){
    return{
      form: {
        email: '',
        passwd: ''
      },
      passwd:'',
      indicator:''
    }
  },
  methods:{
    async loginProcess(){
      this.indicator = "Connecting to the server..."
      let sha256 = require("js-sha256").sha256
      this.passwd = sha256(this.form.passwd)
      axios.post('/login', {
        'Uid': this.form.uid,
        'Password': this.passwd
      })
      .then((response) => {
        if (response.status === 200 && response.data != null) {
          switch (response.data.code){
            case 10507:
              this.indicator = "Custumer does not exist, please check and try again！"
              break  
            case 10509:
              this.indicator = "Passord is incorrect, please check and try again！"
              break  
            case 200:
              this.indicator = ""
              break
              //to do add a page aftear login
            default:
              this.indicator = "Sever error, please try again later！"
          }
        }
      })
      .catch( error => {
        this.indicator = "Sever error, please try again later！"
      })
    }	
	}
};
</script>
<style>
</style>
